import ActionsForm from '@/shared/mixins/actionsForm'
import SearchAnnouncements from './components/searchAnnouncements/searchAnnouncements.vue'
import TableAnnouncements from './components/tableAnnouncements/tableAnnouncements.vue'
import AddAnnouncements from './components/addAnnouncements/addAnnouncements.vue'
import PermissionMixin from '@/store/module/permission/mixin'
import Roles from '@/shared/utils/roles.js'

export default {
  name: 'Annoucements',
  mixins: [ActionsForm, PermissionMixin],
  components: {
    SearchAnnouncements,
    TableAnnouncements,
    AddAnnouncements
  },
  data () {
    return {
      comunicadoInfo: {},
      arrayAnnouncements: null,
      tablereload: 0,
      roles: Roles
    }
  },
  methods: {
    hideModal () {
      this.$root.$emit('bv::hide::modal', 'modal-1')
    },
    openAddModal (obj) {
      this.comunicadoInfo = obj
      this.$refs['add-comunicado'].EditOpenAddModal(obj)
    },
    GetFilter (filter, isFilter) {
      this.$refs.tableAnnouncementsComponent.searchWithFilter(filter, isFilter)
    },
    updateTable () {
      this.tablereload++
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/announcements/announcements.js